<div class="container-fluid">
  <div class="row mk-sp">
    <div class="col-md-12" *ngIf="isLoading">
      <app-busy [message]="message"></app-busy>
    </div>
    <div class="col-12 mrg-b">
      <table class="table">
        <thead>
          <tr>
            <th>Account Number</th>
            <th>Account Name</th>
            <th>Trading Name</th>
            <th>Registration Number</th>
            <th>Permit Number</th>
            <th>Permit Type</th>
            <th>Vehicle Registration Number</th>
          </tr>
          <tr>
            <td>{{compliance.carrierName}}</td>
            <td>{{compliance.carrierNum}}</td>
            <td>{{compliance.carrierRegNum}}</td>
            <td>{{compliance.carrierTradingName}}</td>
            <td>{{compliance.permitNum}}</td>
            <td>{{compliance.permitType}}</td>
            <td>{{compliance.vehicle_reg_num}}</td>
          </tr>
        </thead>
      </table>
    </div>
    <div class="col-12"><hr /></div>
   
      <div class="col-4">
        <label><b class="h4 mth-clr">{{CMonthName +' ' + CYear | uppercase}}</b></label>
      </div>
      <div class="col-8">
        <div class="input-group-text mp-rm pull-right" style="background-color:white!important;border:none!important;">
          <label class="pull-right mp-rm" style="margin-right:3px!important;"><b class="">Make a nil return - no trips undertaken in this period </b></label>
          <input type="checkbox" checked class="form-control form-control-sm pull-right mp-rm" (change)="changeState($event)" data-toggle="modal" data-target="#nilreturnpopup" />
        </div>
      </div>
      <div class="col-12" id='tripId'>
        <table border="1" class="table tbl-stl" cellspacing="1">

          <thead class="thead-inverse hgt-btn">
            <tr style="vertical-align:middle;" class="">
              <th class="h5" *ngFor="let day of CWeekDays">
                {{day}}
              </th>
            </tr>
          </thead>
          <tbody *ngFor="let row of CRows ; let i=index;">
            <tr>
              <td *ngFor="let row of CCols; let j=index;" class="td-hgt" [ngClass]="{'td-clr':increm(i,j)==''}">



                <div class="row">
                  <!--<div class="col-12 text-right"> <span class="lead" [ngClass]="{'text-danger':isToday(i,j)}"><b>{{increm(i,j)}}</b></span></div>-->
                  <!--<div class="col-12" *ngIf="increm(i,j)!=''" style="margin:0px;padding:0px;"><hr/></div>-->
                  <div class="col-12">
                    <trip *ngIf="increm(i,j)!=''" [dataCtrl]="CDays[i][j]"></trip>

                  </div>
                </div>
              </td>

            </tr>
          </tbody>


        </table>
      </div>

   <!-- Modal -->
<div class="modal fade" id="nilreturnpopup" tabindex="-1" role="dialog" aria-labelledby="nilreturnpopup" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered  modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="">Nil Trips Submission</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
     
        <div class="container">
          <div class="row">
            <div class="col-md-6">
             [Carrier Details]
            </div>
            <div class="col-md-6">

             [Permit Number, Type, Vehicle]
            </div>
            <div class="col-md-6">

             [Month]
             </div>
          </div>
        </div>
        
        <form [formGroup]="form">
          <div class="col-md-12 p-0">
            <div class="col-sm-12 p-0">
              <label for="description"> Please provide justification or reason for nil return</label>
                 <br>
              <ckeditor formControlName="nilreturnjustification" debounce="500" style="width: 100%;" [(ngModel)]="model.justification" >
              </ckeditor>
            </div>
          </div>

          <div class="col-md-12 p-0">
            <div class="col-sm-12 p-0">
              <label for="description"> Declaration</label>
                 <br>
              <ckeditor formControlName="nilreturndeclaration" debounce="500" style="width: 100%;" [(ngModel)]="model.declaration" >
              </ckeditor>
            </div>
          </div>

        </form>

      </div>
   
      <div class="modal-footer">
        <button type="button" class="btn btn-md m-clr pull-left hd-btn mr-2 mt-2">Upload supporting doc</button>
        <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2">Save changes</button>
        <button type="button" class="btn btn-md m-clr pull-right hd-btn mt-2" data-dismiss="modal">Close</button>
      </div>
     
        
      </div>
    </div>
  </div>
</div>

</div>
